import React from 'react';
import { Provider } from 'react-redux'
import store from './store'

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from "react-cookie";
import { DndProvider } from 'react-dnd'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { HTML5Backend } from 'react-dnd-html5-backend'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CookiesProvider><DndProvider backend={HTML5Backend}><LocalizationProvider dateAdapter={AdapterDayjs}>
  	  <Provider store={store}>
  	    <div>
  	      <App />
    	  </div>
  	  </Provider>
  	</LocalizationProvider></DndProvider></CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
